exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".user-help-person .el-collapse {\n  border-top: 1px solid #ebeef5;\n  border-bottom: 1px solid #ebeef5;\n}\n.user-help-person .el-collapse-item__header {\n  border-bottom: 1px solid #ebeef5;\n}\n.user-help-person .el-collapse-item__header.is-active {\n  border-bottom-color: transparent;\n}\n.user-help-person .el-collapse-item__wrap {\n  border-bottom: 1px solid #ebeef5;\n}", ""]);
// Exports
exports.locals = {
	"theme": "#00b3ee",
	"menuBg": "#1f2d52",
	"minWidth": "1190",
	"minHeight": "669.375",
	"headerHeight": "60",
	"footerHeight": "60",
	"menuText": "#dae3f2",
	"menuActiveText": "#fff",
	"subMenuActiveText": "#00b3ee",
	"sidebarWidth": "200",
	"treeWidth": "340",
	"crumbsHeight": "60"
};